import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { MEDIA } from "@/lib/media";
import { useSeo } from "@/lib/seo";
import { toast } from "sonner";

export default function Register() {
  useSeo("Create Account", "Join the Happy Bulldog Pack.");
  const { register, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Welcome to the pack! 🐾");
      navigate("/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12">
      <div className="bg-white rounded-[2rem] soft-shadow p-8 sm:p-10 max-w-md w-full">
        <img src={MEDIA.logoArc} alt="The Happy Bulldog Co." className="h-20 w-auto mx-auto" />
        <h1 className="font-display font-extrabold text-2xl text-[#19324A] text-center mt-4">Join the Pack</h1>
        <p className="text-center text-[#19324A]/60 text-sm mt-1">Create your account to track orders & save favourites.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-[#19324A]/70 mb-1">First Name</label>
            <input required value={name} onChange={(e) => setName(e.target.value)} className="w-full rounded-2xl border-2 border-[#19324A]/10 px-4 py-3 outline-none focus:border-[#FFD93D]" data-testid="register-name" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#19324A]/70 mb-1">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-2xl border-2 border-[#19324A]/10 px-4 py-3 outline-none focus:border-[#FFD93D]" data-testid="register-email" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#19324A]/70 mb-1">Password</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-2xl border-2 border-[#19324A]/10 px-4 py-3 outline-none focus:border-[#FFD93D]" data-testid="register-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-pink w-full" data-testid="register-submit">{loading ? "Creating…" : "Create Account"}</button>
        </form>
        <div className="flex items-center gap-3 my-5"><span className="h-px flex-1 bg-[#19324A]/10" /><span className="text-xs text-[#19324A]/40 font-semibold">OR</span><span className="h-px flex-1 bg-[#19324A]/10" /></div>
        <button onClick={loginWithGoogle} data-testid="google-register-btn" className="w-full flex items-center justify-center gap-3 rounded-full border-2 border-[#19324A]/15 bg-white px-6 py-3 font-display font-semibold text-[#19324A] hover:border-[#FFD93D] transition-colors">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" /> Continue with Google
        </button>
        <p className="text-center text-sm text-[#19324A]/60 mt-5">Already have an account? <Link to="/login" className="text-[#FF6B9D] font-semibold">Log in</Link></p>
      </div>
    </div>
  );
}
